module.exports = "fragment MinimalPanelFragment on Panel {\n  __typename\n  name\n  previewUrl(width: 500, fitIn: true)\n  isFullBleed\n  width\n  height\n}\n"